// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","notLoggedIn":"App_notLoggedIn__HwD9A","loggedIn":"App_loggedIn__3-DbT","delete":"App_delete__1btB7","toDos":"App_toDos__2pvHe"};